<template>
    <div class="ag-cell-label-container">
        <div class="ag-header-cell-label">
            <b-form-radio
                v-model="value"
                :value="option"
                :name="name"
                plain
                @change="onChange"
            ></b-form-radio>
            <span class="ag-header-cell-text ml-2">{{ params.displayName }}</span>
        </div>
    </div>
</template>

<script>
    import { ToggleButton } from 'vue-js-toggle-button';

    export default {
        components: {
            ToggleButton,
        },
        computed: {
            paramsValue() {
                return this.params.valueGetter(this.params);
            }
        },
        data() {
            return {
                value: false,
            };
        },
        created() {
            this.value = this.paramsValue;
            this.option = this.params.radioOption && this.params.radioOption(this.params);
            this.name = this.params.radioName || '';
        },
        methods: {
            onChange(value) {
                const newValue = value;
                this.value = newValue;
                if (this.params.onChange) {
                    this.params.onChange(this.params, newValue)
                }
            }
        },
        watch: {
            paramsValue() {
                this.value = this.paramsValue;
            }
        }
    }
</script>
